import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ResponseError } from "@lucaswickstrom/fetch";
import { Alert, DialogContent } from "@mui/material";
import { setMessage, useError } from "@ssf/components";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LoginButton, useAuth } from "./index.js";
export function useAuthError(queryError, onError) {
    const auth = useAuth();
    const { addError } = useError();
    // biome-ignore lint/correctness/useExhaustiveDependencies: Unstable dependencies
    useEffect(() => {
        if (queryError && !onError?.(queryError)) {
            if (queryError instanceof ResponseError &&
                queryError.response.status === 401) {
                setMessage(queryError).then((errorWithMessage) => {
                    addError(errorWithMessage, _jsx(LoginButton, { variant: "text", auth: auth }), _jsx(RequestAuthErrorContent, { err: errorWithMessage }));
                });
            }
            else {
                setMessage(queryError).then((error) => {
                    addError(error);
                });
            }
        }
    }, [queryError]);
}
export function useQueryWithAuthError(queryKey, queryFn, queryOptions, onError) {
    const queryResult = useQuery({
        queryKey,
        queryFn,
        ...queryOptions,
    });
    useAuthError(queryResult.error, onError);
    return queryResult;
}
export function useMutationWithAuthError(mutationKey, mutationFn, mutationOptions, onError) {
    const queryResult = useMutation({
        mutationKey,
        mutationFn,
        ...mutationOptions,
    });
    useAuthError(queryResult.error, onError);
    return queryResult;
}
export const RequestAuthErrorContent = ({ err }) => {
    const { t } = useTranslation("ErrorProvider");
    return (_jsxs(DialogContent, { sx: { pb: 0 }, children: [t("unauthorized"), _jsx(Alert, { severity: "error", sx: { mt: 2 }, children: t(err.message) })] }));
};
//# sourceMappingURL=QueryError.js.map